import $ from 'jquery';
import {trigger} from '../../utils/events';

const HIDE_CLASS = 'jsHide',
    facets = {
        _checkboxes: function (data) {
            $('.facetLabel').on(
                'change',
                'input[type=checkbox]',
                function (e) {
                    var name = e.target.name;

                    this._handleDataChange({
                        name: name,
                        value: e.target.value,
                        shouldAdd: e.target.checked,
                        isMultiSelect: $(e.target).data('multiselect') === 'True',
                        data: data
                    });

                    if (this._hasSelectionsByName(name)) {
                        this._findClearLink(name).removeClass(HIDE_CLASS);
                    }
                }.bind(this)
            );
        },
        _links: function (data) {
            $('#facetedSearch, #searchCrumbs').on(
                'click',
                '.facetLink',
                function (e) {
                    e.preventDefault();

                    var $link = $(e.currentTarget),
                        name = $link.data('name'),
                        shouldAdd = $link.data('selected') === 'False',
                        isMultiSelect = $link.data('multiselect') === 'True';

                    this._handleDataChange({
                        name: name,
                        value: $link.data('value').toString(),
                        shouldAdd: shouldAdd,
                        isMultiSelect: isMultiSelect,
                        data: data
                    });

                    $link.data('selected', shouldAdd ? 'True' : 'False');

                    if (this._hasSelectionsByName(name)) {
                        this._findClearLink(name).removeClass(HIDE_CLASS);
                    }
                }.bind(this)
            );
        },
        _categoryLinks: function () {
            $('#facetedSearch').on('click', 'a[data-categoryid]:not([href="#"])', e => {
                this._triggerEvent({
                    name: 'category',
                    value: e.target.dataset.categoryid
                });
            });
        },
        _dropdowns: function (data) {
            $('.facetDropDown').on(
                'change',
                function (e) {
                    this._handleDataChange({
                        name: e.target.name,
                        value: e.target.value,
                        shouldAdd: true,
                        isMultiSelect: true,
                        data: data
                    });
                }.bind(this)
            );
        },
        _redirectDropdowns: function () {
            $('.redirectDropDown').on('change', function (e) {
                smartPak.page.redirectToUrl(e.target.value);
            });
        },
        _handleDataChange: function (changeData) {
            var data = changeData.data.get(),
                facet = this._findFacetByName(data.Facets, changeData.name);

            if (data.Start > 0) {
                data.Start = 0;
            }

            if (facet && !changeData.isMultiSelect) {
                if (facet) {
                    facet.Values = [];
                }
            }

            if (changeData.shouldAdd) {
                if (!data.Facets) {
                    data.Facets = [];
                }

                if (!facet) {
                    facet = {
                        Name: changeData.name,
                        Values: []
                    };

                    data.Facets.push(facet);
                }

                if (facet.Values.indexOf(changeData.value) === -1) {
                    facet.Values.push(changeData.value);
                }
            } else if (facet) {
                facet.Values = this._removeItemFromArray(changeData.value, facet.Values);

                if (!facet.Values.length) {
                    data.Facets = this._removeItemFromArray(facet, data.Facets);
                }
            }

            changeData.data.set(data);

            this._triggerEvent(changeData);
        },
        _triggerEvent: function ({name, value}) {
            trigger('Facet Interaction', name, value);
        },
        _findFacetByName: function (facets, name) {
            var found = facets.filter(function (facet) {
                return facet.Name.toLowerCase() === name.toLowerCase();
            });
            return found.length ? found[0] : null;
        },
        _removeItemFromArray: function (item, items) {
            var indexOf = items.indexOf(item);
            return items.slice(0, indexOf).concat(items.slice(indexOf + 1, items.length));
        },
        _clearLinks: function (data) {
            $('.facetUndoAll').on(
                'click',
                function (e) {
                    var $link = $(e.target),
                        name = $link.data('name');

                    $link.addClass(HIDE_CLASS);

                    this._handleDataChange({
                        name: name,
                        value: '',
                        shouldAdd: false,
                        isMultiSelect: false,
                        data: data
                    });

                    this._clear(name);
                }.bind(this)
            );
        },
        _hasSelectionsByName: function (name) {
            return this._findSelectedByName(name).length > 0;
        },
        _hasSelection: function ($item) {
            return $item.data('Selected') === 'True' || $item.prop('checked');
        },
        _findSelectedByName: function (name) {
            return this._findByName(name).filter(
                function (index, item) {
                    return this._hasSelection($(item));
                }.bind(this)
            );
        },
        _findByName: function (name) {
            return $('[data-name=' + name + ']:not(.facetUndoAll), [name=' + name + ']:not(.facetUndoAll)');
        },
        _findClearLink: function (name) {
            return $('.facetUndoAll[data-name=' + name + ']');
        },
        _clear: function (name) {
            this._findSelectedByName(name).each(function (index, item) {
                var $item = $(item);
                $item.prop('checked', false).data('Selected', 'False');
            });
        },
        _expandFacetLink: function (name) {
            var facetName = name.charAt().toUpperCase() + name.slice(1),
                $facetElement = $('#facetRefine-' + facetName);

            if ($facetElement.length) {
                $facetElement.children('a').eq(0).trigger('click', 'jqueryTrigger');
            }
        },
        _expandFacetsFromLocalStorage: function () {
            if (this.viewAllFacetsData.facets) {
                this.viewAllFacetsData.facets.forEach(
                    function (facet) {
                        this._expandFacetLink(facet);
                    }.bind(this)
                );
            }
        },
        _bindViewAllLinks: function () {
            $('.facetSelect')
                .next('a')
                .on(
                    'click',
                    function (e, source) {
                        if (source !== 'jqueryTrigger') {
                            var $link = $(e.target),
                                facetId = $link.parent().attr('id'),
                                facetName,
                                facetIndex;

                            if (facetId) {
                                facetName = facetId.replace('facetRefine-', '');
                                if (this.viewAllFacetsData.facets) {
                                    facetIndex = this.viewAllFacetsData.facets.indexOf(facetName);
                                    if (facetIndex === -1) {
                                        this.viewAllFacetsData.facets.push(facetName);
                                    } else {
                                        this.viewAllFacetsData.facets.splice(facetIndex, 1);
                                    }
                                }
                                window.localStorage.setItem('viewAllFacets', JSON.stringify(this.viewAllFacetsData));
                            }
                        }
                    }.bind(this)
                );
        },
        _initViewAllFacets: function () {
            var viewAllFacetsData = (this.viewAllFacetsData = JSON.parse(window.localStorage.getItem('viewAllFacets'))),
                pageTitle = $('#h1Title').text().trim(),
                setViewAllFacetsData;

            if (!viewAllFacetsData || !viewAllFacetsData.page || viewAllFacetsData.page !== pageTitle) {
                setViewAllFacetsData = {
                    page: pageTitle,
                    facets: []
                };
                this.viewAllFacetsData = setViewAllFacetsData;
                window.localStorage.setItem('viewAllFacets', JSON.stringify(setViewAllFacetsData));
            }
        },
        init: function (data) {
            this._checkboxes(data);
            this._links(data);
            this._categoryLinks();
            this._dropdowns(data);
            this._clearLinks(data);
            this._redirectDropdowns();
            this._initViewAllFacets();
            this._bindViewAllLinks();

            data.get()
                .Facets.filter(function (facet) {
                    return facet.Values && facet.Values.length > 0;
                })
                .forEach(
                    function (facet) {
                        this._findClearLink(facet.Name).removeClass(HIDE_CLASS);
                    }.bind(this)
                );

            this._expandFacetsFromLocalStorage();
        }
    };

export default facets;
